import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { push } from "react-router-redux";
import { Field, FieldArray, reduxForm, SubmissionError } from "redux-form";
import LoadingProgress from '../components/LoadingProgress'

import Box from "../components/Box";
import ErrorMessage from "../components/ErrorMessage";
import { fetchCustomer, updateCustomer } from "../actions/customers";
import { fetchSLAs } from "../actions/slas";
import {
  renderInputField,
  renderTextAreaField,
  renderSelectField,
  renderCheckboxField,
} from "../utils/forms";
import ColorPickerField from "../utils/ColorPickerField";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import '../styles/CustomerDetailsView.css'

class CustomerEditForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = { loaded: false };
    this.submit = this.submit.bind(this);
    this.renderItems = this.renderItems.bind(this);
  }

  componentDidMount() {
    const { customers, fetchCustomer, match } = this.props;

    this.props.fetchSLAs();

    if (!customers.customer) {
      fetchCustomer(match.params.id);
    } else {
      this.setState({ loaded: true });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!this.state.loaded && nextProps.customers.customer) {
      this.setState({ loaded: true });
    }
  }

  submit(props) {
    const { updateCustomer, customers } = this.props;

    props.Executor = this.props.fullname;

    return updateCustomer(customers.customer._id, props).then((response) => {
      if (response.error) {
        throw new SubmissionError({
          _error: response.error.message,
          ...response.error.fields,
        });
      }

      return response;
    });
  }

  renderZones(props) {
    const { fields } = props;

    return (
      <div>
        <div className="table-responsive">
          <table className="table table-sm table-stripped">
            <thead className="thead-dark">
              <tr>
                <th scope="col">Zona</th>
                <th scope="col">Descripción</th>
                <th scope="col">Color</th>
                <th scope="col">Mapa</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              {fields.map((zone, index) => (
                <tr key={index}>
                  <td>
                    <Field
                      name={`${zone}.Zone`}
                      type="text"
                      component={renderInputField}
                    />
                  </td>
                  <td>
                    <Field
                      name={`${zone}.Description`}
                      type="text"
                      component={renderInputField}
                    />
                  </td>
                  <td>
                    <div className="d-flex justify-content-center align-items-center form-group">
                      <Field
                        name={`${zone}.Color`}
                        component={ColorPickerField}
                      />
                    </div>
                  </td>
                  <td>
                    <Field
                      name={`${zone}.Map`}
                      type="text"
                      component={renderInputField}
                    />
                  </td>
                  <td>
                    <button
                      className="btn btn-danger mr-1"
                      type="button"
                      onClick={() => fields.remove(index)}
                    >
                      <i className="fas fa-trash mr-1"></i>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="text-right">
          <button
            className="btn bg-vw-light text-white"
            type="button"
            onClick={() => fields.push({})}
          >
            <i className="fas fa-plus mr-1"></i>
            Añadir
          </button>
        </div>
      </div>
    );
  }

  renderItems(props) {
    const { fields } = props;

    const handleDragEnd = (result) => {
      if (!result.destination) {
        return;
      }

      const items = Array.from(fields);
      const [reorderedItem] = items.splice(result.source.index, 1);
      items.splice(result.destination.index, 0, reorderedItem);

      // Manually update the fields array with the new order
      fields.removeAll();

      // Push the reordered items back into the fields array, preserving comission and item.item values
      items.forEach((item) => {
        fields.push({
          item: {
            item: item.item.item,
            comission: item.item.comission,
          },
        });
      });
    };

    return (
      <DragDropContext onDragEnd={handleDragEnd}>
        <div>
          <div className="table-responsive">
            <table className="table table-sm table-stripped">
              <thead className="thead-dark">
                <tr>
                  <th scope="col">Artículo</th>
                  <th scope="col">Comisión Cliente (%)</th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <Droppable droppableId="fields">
                {(provided) => (
                  <tbody ref={provided.innerRef} {...provided.droppableProps}>
                    {fields.map((member, index) => (
                      <Draggable key={index} draggableId={member} index={index}>
                        {(provided) => (
                          <tr
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                          >
                            <td>
                              <Field
                                name={`${member}.item`}
                                component={renderSelectField}
                              >
                                <option value="" key="default">
                                  Selecciona un artículo...
                                </option>
                                <option value="LOCKERBNS" key="LOCKERBNS">Standard</option>
                                <option value="LOCKERCNS" key="LOCKERCNS">Standard Carga</option>
                                <option value="LOCKERBWS" key="LOCKERBWS">Standard XL</option>
                                <option value="LOCKERCWS" key="LOCKERCWS">Standard Carga XL</option>
                                <option value="LOCKERBNM" key="LOCKERBNM">Medium</option>
                                <option value="LOCKERCNM" key="LOCKERCNM">Medium Carga</option>
                                <option value="LOCKERBWM" key="LOCKERBWM">Medium XL</option>
                                <option value="LOCKERCWM" key="LOCKERCWM">Medium Carga XL</option>
                                <option value="LOCKERBNL" key="LOCKERBNL">Large</option>
                                <option value="LOCKERCNL" key="LOCKERCNL">Large Carga</option>
                                <option value="LOCKERBWL" key="LOCKERBWL">Large XL</option>
                                <option value="LOCKERCWL" key="LOCKERCWL">Large Carga XL</option>
                                <option value="LOCKERBNXL" key="LOCKERBNXL">Large 4</option>
                                <option value="LOCKERCNXL" key="LOCKERCNXL">Large 4 Carga</option>
                                <option value="LOCKERBWXL" key="LOCKERBWXL">Large 4 XL</option>
                                <option value="LOCKERCWXL" key="LOCKERCWXL">Large 4 Carga XL</option>
                                <option value="LOCKERBN2XL" key="LOCKERBN2XL">Large 5</option>
                                <option value="LOCKERCN2XL" key="LOCKERCN2XL">Large 5 Carga</option>
                                <option value="LOCKERBW2XL" key="LOCKERBW2XL">Large 5 XL</option>
                                <option value="LOCKERCW2XL" key="LOCKERCW2XL">Large 5 Carga XL</option>
                                <option value="LOCKERBN3XL" key="LOCKERBN3XL">Ski</option>
                                <option value="LOCKERCN3XL" key="LOCKERCN3XL">Ski Carga</option>
                                <option value="LOCKERBW3XL" key="LOCKERBW3XL">Ski XL</option>
                                <option value="LOCKERCW3XL" key="LOCKERCW3XL">Ski Carga XL</option>
                                {/* Voucher/Coupon Locker Types */}
                                <option value="LOCKERXNS" key="LOCKERXNS">Voucher Standard (X)</option>
                                <option value="LOCKERXWS" key="LOCKERXWS">Voucher Standard XL (X)</option>
                                <option value="LOCKERXNM" key="LOCKERXNM">Voucher Medium (X)</option>
                                <option value="LOCKERXWM" key="LOCKERXWM">Voucher Medium XL (X)</option>
                                <option value="LOCKERXNL" key="LOCKERXNL">Voucher Large (X)</option>
                                <option value="LOCKERXWL" key="LOCKERXWL">Voucher Large XL (X)</option>
                                <option value="LOCKERNXL" key="LOCKERNXL">Voucher Large 4 (X)</option>
                                <option value="LOCKERXWXL" key="LOCKERXWXL">Voucher Large 4 XL (X)</option>
                                <option value="LOCKERN2XL" key="LOCKERN2XL">Voucher Large 5 (X)</option>
                                <option value="LOCKERXW2XL" key="LOCKERXW2XL">Voucher Large 5 XL (X)</option>
                                <option value="LOCKERN3XL" key="LOCKERN3XL">Voucher Ski (X)</option>
                                <option value="LOCKERXW3XL" key="LOCKERXW3XL">Voucher Ski XL (X)</option>
                                <option value="TUMBONAS" key="TUMBONAS">
                                  Tumbonas
                                </option>
                                <option value="FLOTADORES" key="FLOTADORES">
                                  Flotadores
                                </option>
                                <option
                                  value="FLOTADORESHALFDAY"
                                  key="FLOTADORESHALFDAY"
                                >
                                  Flotadores Medio Día
                                </option>
                                <option value="FASTPASS" key="FASTPASS">
                                  Fastpass
                                </option>
                              </Field>
                            </td>
                            <td>
                              <Field
                                name={`${member}.comission`}
                                type="text"
                                component={renderInputField}
                              />
                            </td>
                            <td>
                              <button
                                className="btn btn-danger mr-1"
                                type="button"
                                onClick={() => fields.remove(index)}
                              >
                                <i className="fas fa-trash mr-1"></i>
                              </button>
                            </td>
                          </tr>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </tbody>
                )}
              </Droppable>
            </table>
          </div>
          <div className="text-right">
            <button
              className="btn bg-vw-light text-white"
              type="button"
              onClick={() => fields.push({})}
            >
              <i className="fas fa-plus mr-1"></i>
              Añadir
            </button>
          </div>
        </div>
      </DragDropContext>
    );
  }

  render() {
    const { customers, error, pristine, submitting, handleSubmit } = this.props;

    if (!this.state.loaded) {
      if (customers.error) {
        return <ErrorMessage message={customers.error.message} />;
      }

      return <LoadingProgress />
    }

    return (
      <form onSubmit={handleSubmit(this.submit)}>
        <h1>
          <span className="text-vw-dark">EDITAR </span>
          <span className="text-vw-light">CLIENTE</span>
        </h1>
        <div className="row">
          <div className="col">
            <Box title="Cliente" icon="user">
              <Field
                name="Fullname"
                type="text"
                component={renderInputField}
                label="Nombre completo"
              />
              <Field name="LicenseType"
                component={renderSelectField}
                label="Tipo de licencia">
                <option value="BASIC">Básica</option>
                <option value="PRO">Pro</option>
              </Field>
              <Field name="Type" component={renderSelectField} label="Tipo">
                <option value="">Selecciona un tipo de usuario...</option>
                <option value="LICENCIA_BASICA">LICENCIA BÁSICA</option>
                <option value="LICENCIA_PRO">LICENCIA PRO</option>
                <option value="PDA">PDA</option>
                <option value="CASH">CASH CONTROL</option>
                <option value="GROUP">GRUPO</option>
              </Field>
              <Field
                name="Category"
                component={renderSelectField}
                label="Categoria"
              >
                <option value="">Selecciona una categoria...</option>
                <option value="BIGPLAYER">Big player</option>
                <option value="AWATERPARK">A Waterpark</option>
                <option value="BWATERPARK">B Waterpark</option>
                <option value="CWATERPARK">C Waterpark</option>
                <option value="BAQUEIRA">BAQUEIRA</option>
                <option value="MONTARTO">MONTARTO</option>
              </Field>
              <Field
                name="Contact_person"
                type="text"
                component={renderInputField}
                label="Persona de contacto"
              />
              <Field
                name="Email"
                type="text"
                component={renderInputField}
                label="E-mail"
              />
              <Field
                name="Password"
                type="password"
                component={renderInputField}
                label="Password"
              />
              <Field
                name="Address"
                type="text"
                component={renderTextAreaField}
                label="Dirección"
              />
              <Field
                name="Phone"
                type="text"
                component={renderInputField}
                label="Teléfono 1"
              />
              <Field
                name="WhatsAppCommunications"
                component={renderCheckboxField}
                label="Permitir comunicaciones por WhatsApp"
              />
              <Field
                name="SMSCommunications"
                component={renderCheckboxField}
                label="Permitir comunicaciones por SMS"
              />
              <Field
                name="PostalCode"
                type="text"
                component={renderInputField}
                label="Código Postal"
              />
              <Field
                name="City"
                type="text"
                component={renderInputField}
                label="Ciudad"
              />
              <Field
                name="Province"
                type="text"
                component={renderInputField}
                label="Provincia"
              />
              <Field
                name="Language"
                type="text"
                component={renderInputField}
                label="Idioma"
              />
              <Field name="Country" component={renderSelectField} label="País">
                <option value="">Selecciona un país...</option>
                <option value="Albania">Albania</option>
                <option value="Andorra">Andorra</option>
                <option value="Austria">Austria</option>
                <option value="Belarus">Bielorrusia</option>
                <option value="Belgium">Bélgica</option>
                <option value="Bosnia and Herzegovina">Bosnia y Herzegovina</option>
                <option value="Bulgaria">Bulgaria</option>
                <option value="Croatia">Croacia</option>
                <option value="Cyprus">Chipre</option>
                <option value="Czech Republic">Chequia</option>
                <option value="Denmark">Dinamarca</option>
                <option value="Estonia">Estonia</option>
                <option value="Finland">Finlandia</option>
                <option value="France">Francia</option>
                <option value="Germany">Alemania</option>
                <option value="Greece">Grecia</option>
                <option value="Hungary">Hungría</option>
                <option value="Iceland">Islandia</option>
                <option value="Ireland">Irlanda</option>
                <option value="Italy">Italia</option>
                <option value="Kosovo">Kosovo</option>
                <option value="Latvia">Letonia</option>
                <option value="Liechtenstein">Liechtenstein</option>
                <option value="Lithuania">Lituania</option>
                <option value="Luxembourg">Luxemburgo</option>
                <option value="Malta">Malta</option>
                <option value="Moldova">Moldavia</option>
                <option value="Monaco">Mónaco</option>
                <option value="Montenegro">Montenegro</option>
                <option value="Netherlands">Holanda</option>
                <option value="North Macedonia">Macedonia del Norte</option>
                <option value="Norway">Noruega</option>
                <option value="Poland">Polonia</option>
                <option value="Portugal">Portugal</option>
                <option value="Romania">Rumanía</option>
                <option value="Russia">Rusia</option>
                <option value="San Marino">San Marino</option>
                <option value="Serbia">Serbia</option>
                <option value="Slovakia">Eslovaquia</option>
                <option value="Slovenia">Eslovenia</option>
                <option value="Spain">España</option>
                <option value="Sweden">Suecia</option>
                <option value="Switzerland">Suiza</option>
                <option value="Ukraine">Ucrania</option>
                <option value="United Kingdom">Reino Unido</option>
                <option value="Vatican City">Ciudad del Vaticano</option>
                <option value="Turkey">Turquía</option>
              </Field>
              <Field name="SLA" component={renderSelectField} label="SLA">
                <option value="">Selecciona un SLA...</option>
                {this.props.slas && this.props.slas.map(sla => (
                  <option key={sla._id} value={sla._id}>{sla.zone === 'ES_PENINSULA' ? 'España Península' : sla.zone === 'ES_ISLANDS' ? 'España Islas' : sla.zone === 'EU_ZONE1' ? 'Europa Zona 1' : sla.zone === 'EU_ZONE2' ? 'Europa Zona 2' : sla.zone}</option>
                ))}
              </Field>
            </Box>
            <Box title="Extra" icon="file-alt">
              <Field
                name="Group"
                component={renderSelectField}
                label="Grupo al que pertenece"
              >
                <option value="">Selecciona un grupo...</option>
                <option value="ASPRO">ASPRO PARKS</option>
                <option value="GRPR">GRUPO PARQUES REUNIDOS</option>
                <option value="SANTAMARIA">GRUPO SANTAMARIA</option>
                <option value="ISLAMAGICA">GRUPO ISLA MAGICA</option>
              </Field>
              <Field
                name="ExternalId"
                type="text"
                component={renderInputField}
                label="Identificador Externo"
              />
              <Field
                name="IncidencesEmail"
                type="text"
                component={renderInputField}
                label="Email de Reporte"
              />
            </Box>
          </div>
          <div className="col">
            <Box title="Facturación" icon="file-alt">
              <Field
                name="Invoice_taxid"
                type="text"
                component={renderInputField}
                label="NIF/CIF"
              />
              <Field
                name="Invoice_tax"
                type="text"
                component={renderInputField}
                label="IVA aplicable (%)"
              />
              <Field
                name="Social_name"
                type="text"
                component={renderInputField}
                label="Razón social"
              />
              <Field
                name="Invoice_address"
                type="text"
                component={renderInputField}
                label="Dirección de facturación"
              />
            </Box>
            <Box title="Modelo de Negocio" icon="briefcase">
              <Field
                name="BusinessModel"
                component={renderSelectField}
                label="Modelo"
              >
                <option value="">Selecciona un modelo...</option>
                <option value="REVENUE SHARE">REVENUE SHARE</option>
                <option value="SPACE RENTAL">SPACE RENTAL</option>
                <option value="SALE">VENTA</option>
                <option value="RENTAL">ALQUILER</option>
              </Field>
              <Field
                name="Vertical"
                component={renderSelectField}
                label="Vertical"
              >
                <option value="">Selecciona una vertical...</option>
                <option value="Themepark">Waterpark/themepark</option>
                <option value="Ski">Ski</option>
                <option value="FEC">FEC</option>
                <option value="Museum">Museum</option>
                <option value="Stadium">Stadium</option>
                <option value="Zoo">Aquarium/zoo</option>
                <option value="Hotel">Hotel</option>
                <option value="Gym">Gym</option>
                <option value="Other">Other</option>
              </Field>
              <Field
                name="SpaceRentalAlquiler"
                component={renderInputField}
                type="text"
                label="Alquiler Anual"
              />
            </Box>
            <Box title="TPV Virtual" icon="file-alt">
              <Field
                name="Redsys.MERCHANTCODE"
                type="text"
                component={renderInputField}
                label="Código de comercio"
              />
              <Field
                name="Redsys.SECRETKEY"
                type="text"
                component={renderInputField}
                label="Clave de cifrado"
              />
              <Field
                name="Redsys.CURRENCY"
                type="text"
                component={renderInputField}
                label="Moneda"
              />
              <Field
                name="Redsys.TERMINAL"
                type="text"
                component={renderInputField}
                label="Terminal"
              />
              <Field
                name="Redsys.MERCHANTURL"
                type="text"
                component={renderInputField}
                label="URL Tienda"
              />
            </Box>
            <Box title="SAP" icon="file-alt">
              <Field
                name="SAP.Model"
                component={renderSelectField}
                label="Modelo"
              >
                <option value="">Selecciona un modelo...</option>
                <option value="VC">VENTAS CONTADO (Punto de Venta)</option>
                <option value="CV">COMISION VENTA (Solicitud Factura)</option>
              </Field>
              <Field
                name="SAP.CompanyID"
                component={renderSelectField}
                label="CompanyID"
              >
                <option value="">Selecciona una empresa...</option>
                <option value="ES1000">ES1000</option>
                <option value="IT1000">IT1000</option>
              </Field>
              <Field
                name="SAP.CountryCode"
                component={renderSelectField}
                label="CountryCode"
              >
                <option value="">Selecciona un código de país...</option>
                <option value="ES">ESPAÑA</option>
                <option value="IT">ITALIA</option>
                <option value="EU">EUROPA</option>
              </Field>
              <Field
                name="SAP.ClientID"
                type="text"
                component={renderInputField}
                label="ClientID"
              />
              <Field
                name="SAP.SiteID"
                type="text"
                component={renderInputField}
                label="SiteID"
              />
              <Field
                name="SAP.TaxCountryCode"
                type="text"
                component={renderInputField}
                label="TaxCountryCode"
              />
              <Field
                name="SAP.TaxationCharacteristicsCode"
                type="text"
                component={renderInputField}
                label="TaxationCharacteristicsCode"
              />
              <Field
                name="SAP.InventoryManagedLocationID"
                type="text"
                component={renderInputField}
                label="InventoryManagedLocationID"
              />
              <Field
                name="SAP.LogisticsAreaID"
                type="text"
                component={renderInputField}
                label="LogisticsAreaID"
              />
              <Field
                name="SAP.TaxRegionCode"
                type="text"
                component={renderInputField}
                label="TaxRegionCode"
              />
            </Box>
          </div>
          <div className="col">
            <Box title="Artículos" icon="shopping-cart">
              <FieldArray name="Items" component={this.renderItems} />
            </Box>
            <Box title="">
              <FieldArray name="Zones" component={this.renderZones} />
            </Box>
          </div>
        </div>
        {error && <div className="alert alert-danger">{error}</div>}
        <button
          className="btn bg-vw-light text-white mr-1 save"
          type="submit"
          disabled={pristine || submitting}
        >
          Guardar
        </button>
      </form>
    );
  }
}

CustomerEditForm = reduxForm({
  form: "CustomerEditForm",
  enableReinitialize: true,
  onSubmitSuccess: (result, dispatch, props) => {
    props.push(`/customers/${result.response._id}`);
  },
})(CustomerEditForm);

const mapStateToProps = (state) => ({
  customers: state.customers,
  initialValues: state.customers.customer,
  fullname: state.auth.fullname,
  slas: state.slas.slas,
});

const mapDispatchToProps = (dispatch) => ({
  fetchCustomer: bindActionCreators(fetchCustomer, dispatch),
  updateCustomer: bindActionCreators(updateCustomer, dispatch),
  fetchSLAs: bindActionCreators(fetchSLAs, dispatch),
  push: bindActionCreators(push, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(CustomerEditForm);